import React, { memo } from "react";
import { motion } from "framer-motion";
import { Task } from "./components/taskProgress/taskTypes";
import { getTaskStatus } from "./components/taskProgress/utils";
import { TaskProgressItem } from "./components/taskProgress/TaskProgressItem";
import { SearchProgressMetrics } from "@/modules/snapshots/grid/sidebar/search/useSearchProgress";

const TASKS: Task[] = [
  { id: "thinking", label: "Analyzing Query", icon: "", order: 1, description: "Understanding your search query" },
  {
    id: "retrieving",
    label: "Retrieving Documents",
    icon: "",
    order: 2,
    description: "Finding relevant documents",
    fakeDuration: 500,
  },
  { id: "analyzing", label: "Analyzing Results", icon: "", order: 3, description: "" },
];
export interface Props {
  metrics: SearchProgressMetrics;
  thinking?: string;
  relevantFields?: string[];
  documents?: number;
}

export const GridSidebarSearchTaskProgress: React.FC<Props> = memo(
  ({ metrics, thinking, relevantFields, documents }) => (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
      className="mb-4 rounded-lg border border-[#e1ddd6] bg-white p-4 shadow-sm"
    >
      <h3 className="m-0 mb-4 text-sm font-semibold text-gray-700">Search Progress</h3>

      <div className="space-y-3">
        {TASKS.map(task => (
          <TaskProgressItem
            key={task.id}
            task={task}
            status={getTaskStatus(task.id, metrics.phase)}
            metrics={metrics}
            thinking={thinking}
            relevantFields={relevantFields}
            documents={documents}
          />
        ))}
      </div>
    </motion.div>
  ),
);
